import React, {useRef} from 'react';
import {useClientAppStore} from './context';
import _ from 'lodash';
import {Button, Dropdown, Menu, Modal, PageHeader, Typography} from 'antd';
import {Link, useNavigate} from 'react-router-dom';

import {DeleteOutlined, LinkOutlined, MoreOutlined} from '@/icons';
import {deleteClientApp, patchClientApp} from '@/api/clientApps';
import ClientAppMeta from './ClientAppMeta';
import ApiTabs from './ApiTabs';
import TicketUrlModal from './TicketUrlModal';

import styles from './styles.module.less';

function ClientAppInfo() {
    const urlModalRef = useRef();
    const navigate = useNavigate();
    const [{clientAppId, clientApp, reload}] = useClientAppStore();

    const routes = [
        {
            path: '/admin/clientapps',
            breadcrumbName: 'API 群组列表',
        },
        {
            breadcrumbName: 'API 群组详细',
        },
    ];

    function goHome() {
        navigate(routes[0].path);
    }

    function itemRender(route) {
        // console.log('route, params, routes, paths', route, params, routes, paths);
        return route.path ? (
            <Link to={route.path}>{route.breadcrumbName}</Link>
        ) : (
            <span>{route.breadcrumbName}</span>
        );
    }

    function patchClientAppItems(data) {
        if (!_.isPlainObject(data)) {
            throw new Error('patch client app params must be object');
        }

        patchClientApp(clientAppId, data).then(() => {
            reload();
        });
    }

    function onMenuClick({key}) {
        console.log(key);
        if (key === 'genTicketUrl') {
            urlModalRef.current.showModal(clientApp);
        } else if (key === 'delete') {
            Modal.confirm({
                title: '警告',
                content: `确定删除「${clientApp.name}」？`,
                okText: '删除',
                okButtonProps: {danger: true},
                onOk: () => {
                    deleteClientApp(clientApp.id).then(() => {
                        // console.log(data);
                        goHome();
                        reload();
                    });
                },
            });
        }
    }

    const menu = (
        <Menu onClick={onMenuClick}>
            <Menu.Item key="genTicketUrl" icon={<LinkOutlined />}>
                生成跳转链接
            </Menu.Item>
            <Menu.Item key="delete" danger icon={<DeleteOutlined />}>
                删除
            </Menu.Item>
        </Menu>
    );
    const extra = (
        <Dropdown overlay={menu}>
            <Button type="ghost" icon={<MoreOutlined />} />
        </Dropdown>
    );
    return (
        <PageHeader
            onBack={goHome}
            title={
                <Typography.Text
                    editable={{
                        maxLength: 30,
                        tooltip: '编辑标题',
                        onChange: value => {
                            patchClientAppItems({name: value});
                        },
                    }}
                    style={{left: 0, marginTop: 0, marginBottom: 0}}
                >
                    {clientApp?.name || ''}
                </Typography.Text>
            }
            breadcrumb={{routes, itemRender}}
            className={styles.title}
            extra={extra}
        >
            <Typography.Paragraph
                type="secondary"
                editable={{
                    maxLength: 500,
                    autoSize: true,
                    tooltip: '编辑说明',
                    onChange: value => {
                        patchClientAppItems({description: value});
                    },
                }}
                ellipsis={{rows: 1, expandable: true}}
            >
                {clientApp?.description || ''}
            </Typography.Paragraph>

            <ClientAppMeta clientApp={clientApp} reload={reload} />
            <ApiTabs />

            <TicketUrlModal ref={urlModalRef} />
        </PageHeader>
    );
}

export default ClientAppInfo;
